// src/locales/en/users.js
export const users = {
    // Users Page Specific
    manageTeamMembers: "Manage your team members and their access",
    loadingUsers: "Loading Users...",
    loadingUsersDesc: "Please wait while we fetch the user data.",
    unableToLoadUsers: "Unable to Load Users",
    searchUsersPlaceholder: "Search users by name, email...",
    allStatus: "All Status",
    allRoles: "All Roles",
    role: "Role",
    show: "Show",
    perPage: "per page",
    noUsersFound: "No Users Found",
    noUsersFoundDesc: "No users match your current search and filter criteria.",
    noUsersYet: "No Users Yet",
    noUsersYetDesc: "Start building your team by adding your first user.",
    addFirstUser: "Add First User",
    user: "User",
    assignments: "Assignments",
    userAvatarAlt: "{{name}}'s avatar",
    noRoleAssigned: "No role assigned",
    shopCount: "{{count}} shop",
    warehouseCount: "{{count}} warehouse",
    noAssignments: "No assignments",
    viewDetails: "View Details",
    editUser: "Edit User",
    activate: "Activate",
    deactivate: "Deactivate",
    confirmStatusChange: "Are you sure you want to {{action}} user \"{{userName}}\"?",
    statusUpdateSuccess: "User \"{{userName}}\" has been {{status}} successfully.",
    statusUpdateFailed: "Failed to update user status. Please try again.",
    confirmDelete: "Are you sure you want to delete user \"{{userName}}\"? This action cannot be undone.",
    deleteUser: "Delete User",
    deleteSuccess: "User \"{{userName}}\" has been deleted successfully.",
    deleteFailed: "Failed to delete user. Please try again.",
    showingRecords: "Showing {{start}}-{{end}} of {{total}} users",
    firstPage: "First Page",
    previousPage: "Previous Page",
    nextPage: "Next Page",
    lastPage: "Last Page",

    // Create User Page
    createNewUser: "Create New User",
    addNewTeamMember: "Add a new team member to your business",
    backToUsers: "Back to Users",
    
    // Form Sections
    basicInformation: "Basic Information",
    basicInformationDesc: "Provide basic details about the user",
    profilePicture: "Profile Picture",
    profilePictureDesc: "Upload a profile picture (optional)",
    accountSettings: "Account Settings",
    accountSettingsDesc: "Configure user role and login credentials",
    shopAssignment: "Shop Assignment",
    shopAssignmentDesc: "Assign user to specific shops (optional)",
    warehouseAssignment: "Warehouse Assignment",
    warehouseAssignmentDesc: "Assign user to specific warehouses (optional)",
    
    // Form Fields
    fullName: "Full Name",
    fullNamePlaceholder: "Enter full name",
    emailAddress: "Email Address",
    emailPlaceholder: "Enter email address",
    phoneNumber: "Phone Number",
    phonePlaceholder: "Enter phone number",
    employeeNumber: "Employee Number",
    employeeNumberPlaceholder: "Enter employee number",
    address: "Address",
    addressPlaceholder: "Enter address",
    birthday: "Birthday",
    userRole: "User Role",
    selectRole: "Select a role",
    password: "Password",
    passwordPlaceholder: "Enter password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm password",
    accountIsActive: "Account is active",
    defaultShop: "Default Shop",
    selectDefaultShop: "Select default shop",
    defaultWarehouse: "Default Warehouse",
    selectDefaultWarehouse: "Select default warehouse",
    
    // Profile Picture
    clickToUpload: "Click to upload profile picture",
    profilePictureFormats: "PNG, JPG, WEBP up to 5MB",
    
    // Validation Messages
    nameRequired: "Name is required",
    emailRequired: "Email is required",
    invalidEmail: "Please enter a valid email address",
    emailTaken: "This email address is already taken",
    emailAvailable: "Email is available",
    roleRequired: "Please select a user role",
    passwordRequired: "Password is required",
    passwordMinLength: "Password must be at least 6 characters",
    confirmPasswordRequired: "Please confirm your password",
    passwordsDoNotMatch: "Passwords do not match",
    invalidPhone: "Please enter a valid phone number",
    defaultShopRequired: "Please select a default shop when shops are assigned",
    defaultWarehouseRequired: "Please select a default warehouse when warehouses are assigned",
    invalidProfilePictureFormat: "Profile picture must be PNG, JPG, JPEG, or WEBP format",
    profilePictureTooLarge: "Profile picture file size must be less than 5MB",
    
    // Loading States
    loadingData: "Loading Data...",
    loadingDataDesc: "Please wait while we fetch the required information.",
    
    // Actions
    createUser: "Create User",
    
    // Success/Error Messages
    userCreatedSuccess: "User \"{{userName}}\" created successfully!",
    failedToCreateUser: "Failed to create user. Please try again.",
    failedToLoadData: "Failed to load required data. Please try again.",

    // Edit User specific translations
    editUser: "Edit User",
    updateUser: "Update User", 
    updateTeamMember: "Update team member details and permissions",
    changePassword: "Change Password",
    loadingUser: "Loading User...",
    loadingUserDesc: "Please wait while we fetch the user data.",
    userNotFound: "User not found. It may have been deleted.",
    failedToLoadUser: "Failed to load user data. Please try again.",
    noChangesToSave: "No changes have been made to save.",
    userUpdatedSuccess: "User '{{userName}}' updated successfully!",
    failedToUpdate: "Failed to update user. Please try again.",
    confirmDiscardChanges: "You have unsaved changes. Are you sure you want to leave without saving?",
    discardChanges: "Discard Changes",
    noChanges: "No Changes",
    unsavedChanges: "Unsaved Changes",
}